import { gql } from '@apollo/client';

export const GET_FINANCIAL_OVERVIEW = gql`
  query GetFinancialOverview($id: ID!) {
    node(id: $id) {
      ... on OpportunityNode {
        id
        financialOverviewId {
          id
          name
          financialCommentary
          financialAnalysis
          financialImage
          financialImageUrl
          financialOverviewTableUrl
          projectedFinancialModel
          projectedLiquidityAndCreditMetrics
          financialCommentaryImageLayout
        }
      }
    }
  }
`;

export const UPDATE_FINANCIAL_OVERVIEW = gql`
  mutation UpdateFinancialOverview($id: ID!, $values: FinancialOverviewInput!) {
    updateFinancialOverview(id: $id, values: $values) {
      ok
      financialOverview {
        id
        name
        financialCommentary
        financialAnalysis
        financialImage
        financialImageUrl
        projectedFinancialModel
        projectedLiquidityAndCreditMetrics
        financialCommentaryImageLayout
      }
    }
  }
`;

export const UPLOAD_FINANCIAL_IMAGE = gql`
  mutation UploadFinancialImage(
    $id: ID!
    $financialImage: String!
    $financialImageFilename: String
  ) {
    uploadFinancialImage(
      id: $id
      financialImage: $financialImage
      financialImageFilename: $financialImageFilename
    ) {
      ok
      financialOverview {
        id
        financialImage
        financialImageUrl
      }
    }
  }
`;

export interface FinancialOverview {
  financialAnalysis: null | string;
  financialCommentary: null | string;
  financialCommentaryImageLayout: null | string;
  financialImage: null | string;
  financialImageUrl: null | string;
  financialOverviewTableUrl: null | string;
  id: string;
  name: null | string;
  projectedFinancialModel: null | string;
  projectedLiquidityAndCreditMetrics: null | string;
}

export interface FinancialOverviewInput {
  financialAnalysis?: null | string;
  financialCommentary?: null | string;
  financialCommentaryImageLayout?: null | string;
  financialImage?: null | string;
  financialImageFilename?: null | string;
  name?: null | string;
  projectedFinancialModel?: null | string;
  projectedLiquidityAndCreditMetrics?: null | string;
}

export interface GetFinancialOverviewResponse {
  node: {
    __typename: 'OpportunityNode';
    financialOverviewId: FinancialOverview | null;
    id: string;
  } | null;
}

export interface UpdateFinancialOverviewResponse {
  updateFinancialOverview: {
    financialOverview: FinancialOverview | null;
    ok: boolean;
  };
}

export interface UploadFinancialImageResponse {
  uploadFinancialImage: {
    financialOverview: {
      financialImage: null | string;
      financialImageUrl: null | string;
      id: string;
    } | null;
    ok: boolean;
  };
}
